import Button from './styled';

export default Button;
